<template>
  <div>
    <button
      v-if="!confirm && !cancel"
      @click="setConfirm"
      class="btn btn-light btn-sm"
    >
      <i class="fa fa-trash-alt mr-1"></i> <span v-if="label">{{ label }}</span>
    </button>
    <button
      v-if="confirm && !cancel"
      @click="confirmed"
      class="btn btn-danger btn-sm animate__bounceIn"
    >
      <i class="fa fa-exclamation fs-3 fw-boldest text-white mx-1"></i
      ><span v-if="label">Sí, {{ label }}</span>
    </button>
  </div>
</template>
<script>
export default {
  name: "button-delete",
  props: {
    label: {
      type: String,
      default: "",
    },
    cancel: {
      type: Number,
      default: 0,
    },
  },
  data: () => {
    return {
      confirm: false,
    };
  },
  methods: {
    setConfirm() {
      this.confirm = true;

      setTimeout(() => {
        this.confirm = false;
      }, 3000);
    },
    confirmed() {
      this.$emit("onDelete", "aqui datos");
    },
  },
};
</script>
